import { Schedule } from '@/features/accounts/types';
import { type ScheduleControls } from '@/features/accounts/schedule/hooks/useScheduleControls';
import ActionsCell from './cells/ActionsCell';
import DateInterestSummary from '@/features/accounts/schedule/components/DateInterestSummary';
import FormattedAppointment from '@/shared/i18n/components/FormattedAppointment';
import ScheduleStatusLabel from '@/features/accounts/schedule/components/ScheduleStatusLabel';
import ApplicationStateLabel from '@/features/accounts/schedule/components/ApplicationStateLabel';
import ScheduleIdentity from '@/features/accounts/schedule/components/ScheduleIdentity';

interface Props {
  schedule: Schedule;
  actions: ScheduleControls;
}

export default function ScheduleSubRow({ schedule, actions }: Props) {
  return (
    <tr className="bg-slate-50/50 border-t border-slate-100">
      <td className="py-2 pr-4 pl-12">
        <ScheduleIdentity schedule={schedule} />
      </td>

      {/* Status column */}
      <td className="px-4 py-2">
        <span className="text-sm text-slate-600">
          <ScheduleStatusLabel status={schedule.status} />
        </span>
        {!schedule.bookable && <ApplicationStateLabel schedule={schedule} />}
      </td>

      {/* Date Range column */}
      <td className="px-4 py-2 text-sm text-slate-600">
        <DateInterestSummary interest={schedule.date_interest} />
      </td>

      {/* Current Appointment column */}
      <td className="px-4 py-2 text-sm text-slate-600">
        {schedule.current_consular_at && (
          <div className="flex flex-col">
            <FormattedAppointment at={schedule.current_consular_at} />
            {schedule.current_consular_facility && (
              <span className="text-xs text-slate-400">@ {schedule.current_consular_facility.name}</span>
            )}
          </div>
        )}
      </td>

      {/* Actions column */}
      <td className="px-4 py-2">
        <ActionsCell schedule={schedule} actions={actions} />
      </td>

      {/* Empty delete column */}
      <td className="px-2 py-2" />
    </tr>
  );
}
